var map = {
	"./Cheong Machinery Equipment desktop.png": 448,
	"./Cryptobengz NFT Project desktop.png": 31,
	"./Kyzzen desktop.png": 479,
	"./Sentosa NFT Project desktop.png": 817,
	"./Tradecom desktop.png": 882,
	"./XVA Collective desktop.png": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;